// Helper functions for ViewTickets component

// Helper functions for Tailwind CSS classes
export const getPriorityColor = (priority) => {
  switch (priority) {
    case 'HIGH':
      return 'text-red-600';
    case 'MEDIUM':
      return 'text-orange-600';
    case 'LOW':
      return 'text-green-600';
    default:
      return 'text-gray-600';
  }
};

export const getStatusColor = (status) => {
  switch (status) {
    case 'PENDING':
      return 'bg-orange-50 text-orange-600 border-orange-200';
    case 'IN_PROGRESS':
      return 'bg-blue-50 text-blue-600 border-blue-200';
    case 'RESOLVED':
      return 'bg-green-50 text-green-600 border-green-200';
    case 'CLOSED':
      return 'bg-gray-50 text-gray-600 border-gray-200';
    default:
      return 'bg-gray-50 text-gray-600 border-gray-200';
  }
};

// Helper function for ticket search
export const ticketMatchesSearch = (ticket, searchStr) => {
  if (!searchStr) return true;
  
  return (
    (ticket.id?.toString() || '').includes(searchStr) ||
    (ticket.trackingId || '').toLowerCase().includes(searchStr) ||
    (ticket.category || '').toLowerCase().includes(searchStr) ||
    (ticket.requester?.name || '').toLowerCase().includes(searchStr) ||
    (ticket.requester?.email || '').toLowerCase().includes(searchStr) ||
    (ticket.priority || '').toLowerCase().includes(searchStr) ||
    (ticket.status || '').toLowerCase().includes(searchStr) ||
    (ticket.details?.specificProblem || '').toLowerCase().includes(searchStr) ||
    (ticket.details?.documentSubject || '').toLowerCase().includes(searchStr) ||
    (ticket.details?.subject || '').toLowerCase().includes(searchStr) ||
    (ticket.details?.message || '').toLowerCase().includes(searchStr) ||
    (ticket.details?.documentMessage || '').toLowerCase().includes(searchStr) ||
    (ticket.details?.typeOfEquipment || '').toLowerCase().includes(searchStr) ||
    (ticket.details?.modelOfEquipment || '').toLowerCase().includes(searchStr) ||
    (ticket.details?.serialNo || '').toLowerCase().includes(searchStr) ||
    (ticket.details?.accountType || '').toLowerCase().includes(searchStr) ||
    (ticket.details?.actionType || '').toLowerCase().includes(searchStr) ||
    (ticket.details?.taType || '').toLowerCase().includes(searchStr) ||
    (ticket.details?.documentType || '').toLowerCase().includes(searchStr)
  );
};

// Helper function to highlight search text
export const highlightSearchText = (text, searchTerm) => {
  if (!searchTerm || !text) return text;
  
  const stringText = String(text);
  if (searchTerm.trim() === '') return stringText;
  
  // For case-insensitive search
  const searchTermLower = searchTerm.toLowerCase();
  const textLower = stringText.toLowerCase();
  
  if (!textLower.includes(searchTermLower)) return stringText;
  
  const index = textLower.indexOf(searchTermLower);
  const beforeMatch = stringText.substring(0, index);
  const match = stringText.substring(index, index + searchTerm.length);
  const afterMatch = stringText.substring(index + searchTerm.length);
  
  // Return an object with the parts for JSX rendering
  return {
    beforeMatch,
    match,
    afterMatch,
    hasMatch: true
  };
};

// Get category specific field mapping for export
export const getCategoryDetail = (ticket, field) => {
  switch (ticket.category) {
    case 'TROUBLESHOOTING':
      switch (field) {
        case 'subcategory': return ticket.details?.typeOfEquipment || '';
        case 'description': return ticket.details?.specificProblem || '';
        default: return '';
      }
    case 'ACCOUNT_MANAGEMENT':
      switch (field) {
        case 'subcategory': return ticket.details?.accountType || '';
        case 'description': return ticket.details?.actionType || '';
        default: return '';
      }
    case 'DOCUMENT_UPLOAD':
      switch (field) {
        case 'subcategory': return ticket.details?.documentType || '';
        case 'description': return ticket.details?.documentSubject || '';
        default: return '';
      }
    case 'TECHNICAL_ASSISTANCE':
      switch (field) {
        case 'subcategory': return ticket.details?.taType || '';
        case 'description': return ticket.details?.subject || '';
        default: return '';
      }
    default:
      return '';
  }
};

// Date range shortcuts
export const getDateShortcut = (days) => {
  const end = new Date();
  const start = new Date();
  start.setDate(start.getDate() - days);
  
  return {
    startDate: start.toISOString().split('T')[0],
    endDate: end.toISOString().split('T')[0]
  };
};

// Predefined categories
export const ticketCategories = [
  'TROUBLESHOOTING',
  'ACCOUNT_MANAGEMENT',
  'DOCUMENT_UPLOAD',
  'TECHNICAL_ASSISTANCE'
];

// Status options
export const statusOptions = ['PENDING', 'IN_PROGRESS', 'RESOLVED', 'CLOSED'];
